import { Routes, Route } from 'react-router-dom';
import Home from '../features/home/Home';
import Servicios from '../features/services/Servicios';
import AsesoriaTI from '../features/services/pages/servicio/consultoria/AsesoriaTI';
import SoporteEnSitioCDMX from '../features/services/pages/servicio/soporte-ti/SoporteEnSitioCDMX';
import MantenimientoCDMX from '../features/services/pages/servicio/soporte-ti/MantenimientoCDMX';
import SoporteRemotoMX from '../features/services/pages/servicio/soporte-ti/SoporteRemotoMX';
import CreacionPaginasWeb from '../features/services/pages/servicio/digital/CreacionPaginasWeb';
import VideoVigilancia from '../features/services/pages/servicio/seguridad/VideoVigilancia';
import Nosotros from '../features/about/Nosotros';
import Contacto from '../features/contact/Contacto';
import AvisoPrivacidad from '../features/legal/AvisoPrivacidad';
import TerminosUso from '../features/legal/TerminosUso';
import PoliticaCookies from '../features/legal/PoliticaCookies';
import DominiosCatalog from '../features/dominios/pages/DominiosCatalog';
import DominioDetail from '../features/dominios/pages/DominioDetail';
import AdminPanel from '../features/dominios/pages/AdminPanel';

import NotFound from '../features/shared/NotFound';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/servicios" element={<Servicios />} />
      <Route path="/servicios/asesoria-ti" element={<AsesoriaTI />} />
      <Route path="/servicios/soporte-en-sitio-cdmx" element={<SoporteEnSitioCDMX />} />
      <Route path="/servicios/mantenimiento-cdmx" element={<MantenimientoCDMX />} />
      <Route path="/servicios/soporte-remoto-mx" element={<SoporteRemotoMX />} />
      <Route path="/servicios/creacion-paginas-web" element={<CreacionPaginasWeb />} />
      <Route path="/servicios/video-vigilancia" element={<VideoVigilancia />} />
      <Route path="/nosotros" element={<Nosotros />} />
      <Route path="/dominios" element={<DominiosCatalog />} />
      <Route path="/dominios/:domainName" element={<DominioDetail />} />
      <Route path="/panel" element={<AdminPanel />} />
      <Route path="/contacto" element={<Contacto />} />
      <Route path="/legal/aviso-de-privacidad" element={<AvisoPrivacidad />} />
      <Route path="/legal/terminos-de-uso" element={<TerminosUso />} />
      <Route path="/legal/politica-de-cookies" element={<PoliticaCookies />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}